import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="py-16 text-center">
      <h2 className="text-lg font-semibold text-slate-900">Page not found</h2>
      <p className="mt-1 text-sm text-slate-500">That address doesn&rsquo;t match anything here.</p>
      <Link to="/" className="mt-4 inline-block text-sm text-orange-600 underline">
        Back to the start
      </Link>
    </div>
  );
}
